import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { fullValidateRegex } from "../../../utils/acquisition-utils";
import { hasDefaultComponent } from "../../../utils/pageModelUtils";
import { isFieldInvalid, TFieldValidationResult } from ".";


export const personalInformationFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const {
        firstName,
        lastName,
        mailingAddressLineOne,
        mailingAddressLineTwo,
        mailingAddressCity,
        mailingAddressState,
        mailingAddressZipCode,
        homeAddressLineOne,
        homeAddressLineTwo,
        homeAddressCity,
        homeAddressState,
        homeAddressZipCode,
    } = validatingState.getPersonalInformation();
    const validationResults: TFieldValidationResult = {};

    if (hasDefaultComponent('cob-corp-acquisition/components/creditonebank/personal-information-form')){
        // Applicant Name
        if (isFieldInvalid(firstName) || fullValidateRegex('first_name', firstName.value)) {
            validationResults['FirstName'] = 'RequiredField';
        }
        if (isFieldInvalid(lastName) || fullValidateRegex('last_name', lastName.value)) {
            validationResults['LastName'] = 'RequiredField';
        }
    
        // Mailing Address
        if (isFieldInvalid(mailingAddressLineOne)) {
                validationResults['MailingAddressLine1'] = 'RequiredField';
        }
        // if (isFieldInvalid(mailingAddressLineTwo)) {
        //     validationResults['MailingAddressLine2'] = 'RequiredField';
        // }
        if (isFieldInvalid(mailingAddressCity)) {
            validationResults['MailingCity'] = 'RequiredField'
        }
        if (isFieldInvalid(mailingAddressState)) {
            validationResults['MailingState'] = 'RequiredField';
        }
        if (isFieldInvalid(mailingAddressZipCode)) {
            validationResults['MailingZipCode'] = 'RequiredField';
        }
    
        if (mailingAddressLineOne.value === mailingAddressLineTwo.value) {
            validationResults['AddrAndAptNumMatch'] = 'NotValid';
        }
    
        // Home Address
        const validateHomeAddress = true;
        if (validateHomeAddress) {
            if (isFieldInvalid(homeAddressLineOne)) {
                validationResults['HomeAddressLine1'] = 'RequiredField';
            }
            // if (isFieldInvalid(homeAddressLineTwo)) {
            //     validationResults['HomeAddressLine2'] = 'RequiredField';
            // }
            if (isFieldInvalid(homeAddressCity)) {
                validationResults['HomeCity'] = 'RequiredField';
            }
            if (isFieldInvalid(homeAddressState)) {
                validationResults['HomeState'] = 'RequiredField';
            }
            if (isFieldInvalid(homeAddressZipCode)) {
                validationResults['HomeZipCode'] = 'RequiredField';
            }
    
            if (homeAddressLineOne.value === homeAddressLineTwo.value) {
                validationResults['HomeAddrAndAptNumMatch'] = 'NotValid';
            }
    
            // TODO: Was this being handled before?
            if (mailingAddressLineOne.value === homeAddressLineTwo) {
                validationResults['IsMailingHomeAddressSame'] = 'NotValid';
            }
        }
    }

    return validationResults;
}

export const ssnFieldValidation = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const { isSsnInfoValid, ssnInfo } = validatingState.getSsn();
    const validationResult: TFieldValidationResult = {};
    if (
        hasDefaultComponent(
            'cob-corp-acquisition/components/creditonebank/ssn-module',
        ) &&
        (!isSsnInfoValid || ssnInfo?.length < 9)
    ) {
        if (!ssnInfo) {
            validationResult['Ssn'] = 'RequiredField';
        }
        if (ssnInfo && ssnInfo.length < 9) {
            validationResult['Ssn'] = 'NotValid';
        }
    }
    return validationResult;
}